<template>
  <div
    class="relative text-yapgray-500"
    :class="{
      'cursor-pointer': !readonly,
      'bg-yapgray-100 text-yapgray-600 dark:bg-yapdarkgray-900 dark:text-yapgray-200': readonly
    }"
    @click="triggerModal"
  >
    <div class="mt-0.5 w-full whitespace-nowrap pb-1 pl-2 pr-4 text-xs">
      {{ t('app.payments.standingApproval.title') }}
    </div>
    <div class="relative -mt-1 flex w-full items-center justify-between px-3">
      <div class="font-normal text-yapgray-800 dark:text-primary-dark-100" v-if="hasStandingApprovals">
        {{ t('webapp.payments.invoice.standingApproval.active') }}
      </div>
      <div class="font-normal text-yapgray-800 dark:text-primary-dark-100" v-else>
        {{ t('webapp.payments.invoice.standingApproval.inactive') }}
      </div>

      <YapIcon
        name="on-outline"
        class="h-4 w-4"
        :class="hasStandingApprovals ? 'text-primary-800 dark:text-primary-dark-600' : 'rotate-180'"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@/plugins/i18n';
import YapIcon from '@/components/YapIcon.vue';

const { t } = useI18n();

const props = defineProps<{
  openModal: () => void;
  hasStandingApprovals: boolean;
  readonly?: boolean;
}>();

function triggerModal() {
  if (props.readonly) return;
  props.openModal();
}
</script>
